/**
 * Updates the recently viewed products in localStorage.
 */
export class RecentlyViewed {
  /** @static @constant {string} The key used to store the viewed product IDs in localStorage */
  static #STORAGE_KEY = 'viewedProducts';
  /** @static @constant {string} The key used to store the full viewed product data in localStorage */
  static #DATA_STORAGE_KEY = 'viewedProductsData';
  /** @static @constant {number} The maximum number of products to store */
  static #MAX_PRODUCTS = 8;

  /**
   * Adds a product to the recently viewed products list.
   * Accepts either a product ID string (legacy) or a full product data object.
   * @param {string|{id: string, handle: string, title: string, image: string, price: number, url: string}} data
   */
  static addProduct(data) {
    try {
      const productId = typeof data === 'string' ? data : data.id;

      let viewedProducts = this.getProducts();
      viewedProducts = viewedProducts.filter((/** @type {string} */ id) => id !== productId);
      viewedProducts.unshift(productId);
      viewedProducts = viewedProducts.slice(0, this.#MAX_PRODUCTS);
      localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts));

      if (typeof data === 'object' && data !== null) {
        let productDataList = this.getProductData();
        productDataList = productDataList.filter((/** @type {{id: string}} */ item) => item.id !== productId);
        productDataList.unshift(data);
        productDataList = productDataList.slice(0, this.#MAX_PRODUCTS);
        localStorage.setItem(this.#DATA_STORAGE_KEY, JSON.stringify(productDataList));
      }
    } catch (e) {

    }
  }

  static clearProducts() {
    try {
      localStorage.removeItem(this.#STORAGE_KEY);
      localStorage.removeItem(this.#DATA_STORAGE_KEY);
    } catch (e) {

    }
  }

  /**
   * Retrieves the list of recently viewed product IDs from localStorage.
   * @returns {string[]} The list of viewed product IDs.
   */
  static getProducts() {
    try {
      return JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  /**
   * Retrieves the full product data for recently viewed products.
   * @returns {Array<{id: string, handle: string, title: string, image: string, price: number, url: string}>}
   */
  static getProductData() {
    try {
      return JSON.parse(localStorage.getItem(this.#DATA_STORAGE_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }
}
